import {Flash as ActionIcon,} from "iconoir-react";
import {Dropdown} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import './ActionsDropdown.scss'

interface ActionsDropdownProps {
    children?: React.ReactNode
    size?: "sm"
}

export const ActionsDropdown = ({children, size} : ActionsDropdownProps) =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslation();

    const sizeClass = size === "sm" ? "btn-sm" : undefined;

    return (
        <Dropdown className="actions-dropdown">
            <Dropdown.Toggle variant="success" className={sizeClass}>
                {t("common.actions")}  <ActionIcon/>
            </Dropdown.Toggle>
            <Dropdown.Menu className="z-index-popover">
                {children}
            </Dropdown.Menu>
        </Dropdown>
    )
}
